import { clearFilterParams } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { useCustomToken, useSessionPermission } from '@btime/react-session'
import React from 'react'

import { sessionsClient } from '../../../utils/apollo/api'
import { useOpenEditPublicTokenModal } from '../../../utils/routes/modals/modalsActions'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query PublicTokens($page: Int, $search: String, $sort: PublicTokenSort, $filter: PublicTokenFilter) {
    publicTokens(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      type
      action
      token
    }
  }
`

const usePublicTokensLoader = filter => {
  const formToken = useCustomToken('formToken')
  const query = usePromiseQuery(QUERY, { client: sessionsClient })
  return (search, page = 1) => {
    return query({ search, page, formToken, filter: clearFilterParams(filter || {}) })?.then(
      pathOr([], ['data', 'publicTokens'])
    )
  }
}

const PublicTokenSelect = ({ onChange, value, address, filter, entity, ...props }) => {
  const canCreateNew = useSessionPermission('createPublicToken')
  const getOptions = usePublicTokensLoader(filter)
  const openPublicTokensModal = useOpenEditPublicTokenModal({ outside: true })

  return (
    <>
      <Select
        value={value} //
        onChange={onChange}
        onCreate={
          canCreateNew &&
          (name => {
            openPublicTokensModal({ onSave: onChange, entity, initialState: { name } })
          })
        }
        options={getOptions}
        {...props}
      />
    </>
  )
}

export default PublicTokenSelect
